import { intl } from 'tci18n-vue2'
// 轻文档CDN地址/SDK ID
export const LIGHT_DOC = {
  ORIGIN: process.env.VUE_APP_BASE_URL,
  URL: process.env.VUE_APP_BASE_URL + '/note',
  PRODUCTION_SDK_ID: '22860126627',
  STAGE_SDK_ID: '22850220759',
  QA_SDK_ID: '22730119877'
};

// WPS 文件保存状态
export const FILE_STATUS = {
  1: intl.$t("版本保存成功, 触发场景：手动保存、定时保存、关闭网页#!!!#src/constants/file.js_1"),
  0: intl.$t("自动保存所有内容#!!!#src/constants/file.js_1"),
  2: intl.$t("暂不支持保存空文件, 触发场景：内核保存完后文件为空#!!!#src/constants/file.js_1"),
  3: intl.$t("空间已满#!!!#src/constants/file.js_1"),
  4: intl.$t("保存中请勿频繁操作，触发场景：服务端处理保存队列已满，正在排队#!!!#src/constants/file.js_1"),
  5: intl.$t("保存失败#!!!#src/constants/file.js_1"),
  6: intl.$t("正在保存到云端...#!!!#src/constants/file.js_1"),
  7: intl.$t("已自动保存在云端#!!!#src/constants/file.js_1")
};

// 需要隐藏的WPS 组件
export const WPS_HIDE_COMPONENTS = [
'FloatQuickHelp'
// 'HeaderLeft',
// 'HeaderMiddle',
// 'HeaderRight',
];

// 需要隐藏的WPS 组件
export const MOBILE_WPS_HIDE_COMPONENTS = [];

export const SCOPE_LIST = ['PUBLIC', 'ORGANIZATION', 'COLLABORATOR'];
export const AUTH_LIST = ['READ', 'READ_DOWNLOAD', 'WRITE', 'ALL'];

/*  分享范围列表
    ['仅文档协作者可通过链接访问', 
    '组织内获得链接的人仅查看',
    '组织内获得链接的人可查看下载',
    '组织内获得链接的人可编辑',
    '互联网上获得链接的人可查看下载']
*/
export const SHARE_SCOPE_LIST = [intl.$t("仅文档协作者可通过链接访问#!!!#src/constants/file.js_1"), intl.$t("内获得链接的人仅查看#!!!#src/constants/file.js_1"), intl.$t("内获得链接的人可查看下载#!!!#src/constants/file.js_1"), intl.$t("内获得链接的人可编辑#!!!#src/constants/file.js_1"), intl.$t("互联网上获得链接的人仅查看#!!!#src/constants/file.js_1"), intl.$t("互联网上获得链接的人可查看下载#!!!#src/constants/file.js_1")];








export const SHARE_SCOPE_SUMMARY_LIST = [intl.$t("仅协作者可见#!!!#src/constants/file.js_1"), intl.$t("企业内公开#!!!#src/constants/file.js_1"), intl.$t("企业内公开#!!!#src/constants/file.js_2"), intl.$t("企业内公开#!!!#src/constants/file.js_3"), intl.$t("互联网公开#!!!#src/constants/file.js_1"), intl.$t("互联网公开#!!!#src/constants/file.js_2"), intl.$t("互联网公开#!!!#src/constants/file.js_3")];









export const COPY_PERMISSION = [
{ id: 'ANYONE_CAN_READ', name: intl.$t("可查看用户#!!!#src/constants/file.js_1"), desc: intl.$t("所有能看到文档的人都能复制#!!!#src/constants/file.js_1") },
{ id: 'ANYONE_CAN_READ_DOWNLOAD', name: intl.$t("可下载用户#!!!#src/constants/file.js_1"), desc: intl.$t("有下载、编辑、所有权限的人能复制#!!!#src/constants/file.js_1") },
{ id: 'ANYONE_CAN_WRITE', name: intl.$t("可编辑用户#!!!#src/constants/file.js_1"), desc: intl.$t("有编辑、所有权限的人能复制#!!!#src/constants/file.js_1") }];


// 这个顺序不要改，权限是逐渐递增
// EditView中的 isCanCopy 依赖这里，需要同步更新
export const BATCH_AUTH_DETAIL_LIST = [
{ id: 'READ', name: intl.$t("仅查看#!!!#src/constants/file.js_1"), desc: intl.$t("仅可在线预览，不能下载#!!!#src/constants/file.js_1") },
{ id: 'READ_DOWNLOAD', name: intl.$t("查看下载#!!!#src/constants/file.js_1"), desc: intl.$t("可在线预览和下载#!!!#src/constants/file.js_1") },
{ id: 'WRITE', name: intl.$t("编辑#!!!#src/constants/file.js_1"), desc: intl.$t("可查看下载/新建/上传/编辑/重命名#!!!#src/constants/file.js_1") },
{ id: 'ALL', name: intl.$t("所有权限#!!!#src/constants/file.js_1"), desc: intl.$t("可查看下载/新建/上传/编辑/重命名/移动/删除/权限管理#!!!#src/constants/file.js_1") }];


export const AUTH_DETAIL_LIST = [
{ id: 'READ', name: intl.$t("仅查看#!!!#src/constants/file.js_2"), desc: intl.$t("仅可在线预览，不能下载#!!!#src/constants/file.js_2") },
{ id: 'READ_DOWNLOAD', name: intl.$t("查看下载#!!!#src/constants/file.js_2"), desc: intl.$t("可在线预览和下载#!!!#src/constants/file.js_2") },
{ id: 'WRITE', name: intl.$t("编辑#!!!#src/constants/file.js_2"), desc: intl.$t("可查看下载/新建/上传/编辑/重命名#!!!#src/constants/file.js_2") },
{
  id: 'ALL',
  name: intl.$t("所有权限#!!!#src/constants/file.js_2"),
  desc: intl.$t("可查看下载/新建/上传/编辑/重命名/移动/删除/权限管理#!!!#src/constants/file.js_2")
},
// { id: 'NONE', name: '无权限', desc: '无法访问' },
{ id: 'DELETE', name: intl.$t("删除协作者#!!!#src/constants/file.js_1") }
// { id: 'RECOVER', name: '恢复继承于父级的权限' }
];

export const EDITOR_ENV_MAP = {
  development: 'development',
  qa: 'test',
  stage: 'uat',
  production: 'production'
};

export const EDITOR_MODE = {
  edit: 'EDIT',
  preview: 'PREVIEW'
};

export const FileStatus = {
  '-1': intl.$t("上传失败#!!!#src/constants/file.js_1"), // 上传失败
  '0': intl.$t("等待上传#!!!#src/constants/file.js_1"), // 等待上传
  '1': intl.$t("传输中#!!!#src/constants/file.js_1"), // 传输中
  '2': intl.$t("已暂停#!!!#src/constants/file.js_1"), // 暂停中
  '3': intl.$t("已上传#!!!#src/constants/file.js_1") // 已上传
};